import { render, staticRenderFns } from "./createMaquininhas.vue?vue&type=template&id=4667d831&scoped=true&"
import script from "./createMaquininhas.vue?vue&type=script&lang=js&"
export * from "./createMaquininhas.vue?vue&type=script&lang=js&"
import style0 from "./createMaquininhas.vue?vue&type=style&index=0&id=4667d831&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4667d831",
  null
  
)

export default component.exports